"use client";

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Pagination } from "./Pagination";
import TicketRow from "./TicketRow";
import { Switch } from "./ui/switch";
import { Label } from "./ui/label";
import { useState } from "react";


declare interface TicketsTableProps {
  tickets: Ticket[];
  page:number;
  totalPages: number;
  isDisplayCommissions:boolean;
}

const TicketsTable = ({
  tickets,
  page,
  totalPages = 0,
  isDisplayCommissions=true
}: TicketsTableProps) => {

  const [displayAll, setDisplayAll] = useState(true);

  return (
  
    <div className="flex flex-col items-center">
      
    <div className=" w-full p-2"> 
    
        {isDisplayCommissions  && (<div className="flex items-center space-x-2 ">
            <Switch id="airplane-mode" className={`shadow-sm  ${displayAll ? 'bg-slate-100' : 'bg-slate-50'} `}
            
            checked={displayAll}
            onCheckedChange={setDisplayAll}
            />
          
          <Label htmlFor="airplane-mode">{displayAll && <span className="text-12 lg:text-14 font-normal text-gray-600 m-2">Ne pas afficher les commissions - Vous gagnez des commissions pour chaque achat (voir colonne Commissions)</span>}</Label>
        </div>)}
    
      </div>
      <Table>
        <TableHeader className="bg-[#f9fafb]">
          <TableRow>
            <TableHead className="px-2">Date d&apos;achat</TableHead>
            <TableHead className="px-2">Référence</TableHead>
            <TableHead className="px-2">Activité</TableHead>
            <TableHead className="px-2">Contact Client</TableHead>
            <TableHead className="px-2">Tickets</TableHead>
            <TableHead className="px-2"></TableHead>
            {displayAll && <TableHead className="px-2">Commissions</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {tickets.map((ticket: Ticket, i) => (
            <TicketRow
              key={i}
              ticket={ticket}
              displayAll={displayAll}
            />
          ))}
        </TableBody>
      </Table>

      <Pagination page={page} totalPages={totalPages} />
    </div>
  );
};

export default TicketsTable;
